<template>
    <div class=" sm:block">
     <is-manager>
       <clients-form />
     </is-manager>
      <div class="mt-5 mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col mt-2">
          <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            <table  v-if="clients" class="min-w-full divide-y divide-gray-200">
              <thead>
              <tr>
                <th class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                 Clients
                </th>
                <th scope="col" class="relative px-6 py-3">
                  <span class="sr-only">Edit</span>
                </th>

              </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
              <router-link
                  class="bg-white hover:bg-gray-100 group  space-x-2 truncate text-sm table-row"
                  tag="tr"
                  v-for="client in clients"
                  :to="'/client/'+client.id"
                  :key="client.id"
                  >
                <td class=" px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  <div class="flex">
                      <p class="text-gray-500 text-lg truncate group-hover:text-gray-900" >
                        <img  class="inline-block h-10 w-10 rounded-full mr-10" v-if="client.image"
                             :src="client.image" alt="" />
                        {{ client.name }}
                      </p>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <is-manager>
                    <button  class="text-red-500 hover:text-red-900" @click.prevent="() => { activeClient = client; dangerModalIsOpen = true }">
                      Delete
                    </button>
                  </is-manager>

                </td>

              </router-link>
              </tbody>
            </table>
            <danger-modal
                :open="dangerModalIsOpen"
                title="Are you sure you want to destroy this client?"
                content="This action CANNOT be undone."
                cancel-button-text="Cancel"
                action-button-text="Destroy"
                v-on:modal:cancel="() => { dangerModalIsOpen = false; activeClient = null }"
                v-on:modal:perform="handleDeleteClient" />
            <!-- Pagination -->
            <nav class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" aria-label="Pagination">
              <div class="hidden sm:block">
                <p class="text-sm text-gray-700">
                  Showing
                  {{ ' ' }}
                  <span class="font-medium">1</span>
                  {{ ' ' }}
                  to
                  {{ ' ' }}
                  <span class="font-medium">1</span>
                  {{ ' ' }}
                  of
                  {{ ' ' }}
<!--                  <span class="font-medium" > {{ clients.length }}</span>-->
                  {{ ' ' }}
                  results
                </p>
              </div>
              <div class="flex-1 flex justify-between sm:justify-end">
                <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Previous
                </a>
                <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Next
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import ClientsForm from "@/components/Clients/ClientsForm";
import DangerModal from "@/components/Functional/Modal/DangerModal";
import IsAdmin from "@/components/Authorization/IsAdmin";
import IsManager from "@/components/Authorization/IsManager";

export default {
  name: "Clients",
  components: {IsManager, IsAdmin, ClientsForm, DangerModal},
  async mounted() {
    this.$store.dispatch('showLoadingSpinner')
    try {
      await this.$store.dispatch('getClients')
    } catch (e) {
     this.$store.dispatch('createAlert', {
       type: 'danger',
       message: e
     })
    }
    this.$store.dispatch('hideLoadingSpinner')
  },
  data() {
    return {
      dangerModalIsOpen: false,
      activeClient: null
    }
  },
  methods: {
    async handleDeleteClient() {
      this.$store.dispatch('showLoadingSpinner')
      try {
        await this.$store.dispatch('deleteClient', this.activeClient)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Client successfully deleted'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
        this.dangerModalIsOpen = false
        this.activeClient = null
        this.$store.dispatch('hideLoadingSpinner')
      }
      this.dangerModalIsOpen = false
      this.activeClient = null
      this.$store.dispatch('hideLoadingSpinner')
    }
  },
  computed: {
    clients() {
      return this.$store.getters.getClients
    },

  }
}
</script>

<style scoped>

</style>
